import { render, staticRenderFns } from "./VitalSigns.vue?vue&type=template&id=4f320928&scoped=true&"
import script from "./VitalSigns.vue?vue&type=script&lang=js&"
export * from "./VitalSigns.vue?vue&type=script&lang=js&"
import style0 from "./VitalSigns.vue?vue&type=style&index=0&id=4f320928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f320928",
  null
  
)

export default component.exports